module.exports = __webpack_public_path__ + "img/serve1.7da0c9cf.png";